import {Injectable, inject} from '@angular/core';
import find from 'lodash/find';
import {lastValueFrom} from 'rxjs';
import {ApiNogaIndustriesService} from '../../../infrastructure/api/common-feature/api-noga-industries/api-noga-industries.service';
import {ErrorService} from '../../../infrastructure/page/error/error/error.service';
import {INogaIndustry} from '../../../../models/noga-industries.model';
import {AppTranslateService} from '../../../infrastructure/page/i18n/translate/app-translate/app-translate.service';
import {Constants} from '../../../../common/constants/constants';
import {getEmptyTranslations} from '../../../../common/functions/language';
import {getTextForTooltip} from '../../../../common/functions/string';
import {NogaTitlePipe} from '../../../../pipes/noga-title/noga-title.pipe';

@Injectable({
  providedIn: 'root',
})
export class NogaIndustriesService {

  private nogaTitlePipe = inject(NogaTitlePipe);

  private apiNogaIndustriesService = inject(ApiNogaIndustriesService);

  private appTranslateService = inject(AppTranslateService);

  private errorService = inject(ErrorService);

  public nogaIndustriesData: INogaIndustry[] = [];

  /**
   * Method: Get noga industries
   */
  public async getNogaIndustries(): Promise<void> {
    try {
      const result = await lastValueFrom(this.apiNogaIndustriesService.getNogaIndustriesObservable());
      this.nogaIndustriesData = result?.data?.nogaIndustries || [];
      this.errorService.showResponseErrors(result);
    } catch (err) {
      this.errorService.showGraphQLErrors(err);
    }
  }

  /**
   * Method: Get noga industry by code
   * @param code
   */
  public getNogaIndustryByCode(code: string): INogaIndustry {
    return find(this.nogaIndustriesData, ['code', code]) ?? null;
  }

  /**
   * Method: Get title noga industry from object INogaIndustry
   * @param item
   */
  public getTitleNogaIndustry(item: INogaIndustry): string {
    const nogaIndustry = this.getNogaIndustryByCode(item?.code);
    const noga = nogaIndustry || {code: item.code, ...getEmptyTranslations()};
    return this.nogaTitlePipe.transform(noga);
  }

  /**
   * Method: Show name selected options
   * @param selectedOptions
   */
  public showSelectedOptions(selectedOptions: INogaIndustry[]): string {
    return selectedOptions?.length
      ? selectedOptions.map(item => this.getTitleNogaIndustry(item)).join(Constants.COMMA_SPACE)
      : '';
  }

  /**
   * Method: Show short name selected options
   * @param selectedOptions
   */
  public showShortSelectedOptions(selectedOptions: INogaIndustry[]): string {
    return getTextForTooltip(this.showSelectedOptions(selectedOptions));
  }

  /**
   * Method: Show value selected Noga
   */
  public showValueSelectedOptions(selectedOptions: INogaIndustry[]): string {
    return selectedOptions.length === this.nogaIndustriesData.length
      ? this.appTranslateService.getTranslation('front.sng.title.all.industries')
      : this.showSelectedOptions(selectedOptions);
  }

}
